<template>
    <CustomDialog
        v-model="visible"
        :defaultTitle="$t('experience.step4.sharedSpaceWarning.modalTitle')"
        @confirm="$emit('confirm')"
        @cancel="close"
        width="550px"
    >
        <template #content>
            <div class="ppv2-flex ppv2-flex-col ppv2-gap-4 ppv2-p-2">
                <div
                    class="ppv2-flex ppv2-items-start ppv2-gap-3 ppv2-bg-amber-50 ppv2-border ppv2-border-amber-200 ppv2-rounded-xl ppv2-p-4"
                >
                    <AlertTriangle :size="20" class="ppv2-text-amber-500 ppv2-flex-shrink-0 ppv2-mt-0.5" />
                    <p class="poppinsLight ppv2-text-amber-700 ppv2-m-0" :style="{ fontSize: normalizeFontSize(13) }">
                        {{ $t('experience.step4.sharedSpaceWarning.modalMessage') }}
                    </p>
                </div>

                <div v-if="sharedSpaces.length > 0" class="ppv2-flex ppv2-flex-col ppv2-gap-3">
                    <p class="poppinsSemiBold ppv2-text-black ppv2-m-0" :style="{ fontSize: normalizeFontSize(13) }">
                        {{ $t('experience.step4.sharedSpaceWarning.affectedExperiences') }}
                    </p>

                    <div
                        v-for="space in sharedSpaces"
                        :key="space.space_id"
                        class="ppv2-border ppv2-border-gray-200 ppv2-rounded-xl ppv2-p-3"
                    >
                        <p
                            class="poppinsSemiBold ppv2-text-black ppv2-m-0 ppv2-mb-2"
                            :style="{ fontSize: normalizeFontSize(12) }"
                        >
                            {{ space.space_name }}
                        </p>
                        <ul class="ppv2-m-0 ppv2-pl-4">
                            <li
                                v-for="exp in space.experiences"
                                :key="exp.id"
                                class="poppinsLight ppv2-text-gray-600 ppv2-mb-1"
                                :style="{ fontSize: normalizeFontSize(12) }"
                            >
                                {{ exp.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>

        <template #actions>
            <BaseButton
                type="button"
                variant="primary"
                @click="$emit('confirm')"
                customClass="!ppv2-min-h-[40px] !ppv2-h-[45px] !ppv2-min-w-[135px]"
                :customHeight="43"
            >
                {{ $t('experience.step4.sharedSpaceWarning.confirmButton') }}
            </BaseButton>
            <BaseButton
                type="button"
                variant="outline"
                @click="close"
                customClass="!ppv2-min-h-[40px] !ppv2-h-[45px] !ppv2-min-w-[135px] ppv2-bg-white dark:ppv2-bg-dark-popup"
                :customHeight="43"
            >
                {{ $t('experience.step4.sharedSpaceWarning.cancelButton') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import { AlertTriangle } from 'lucide-vue'
import CustomDialog from '../../../../components/Shared/CustomDialog.vue'
import BaseButton from '../../../../components/Shared/BaseButton.vue'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'SharedSpaceWarningModal',
    components: {
        AlertTriangle,
        CustomDialog,
        BaseButton,
    },
    props: {
        value: { type: Boolean, default: false },
        sharedSpaces: { type: Array, default: () => [] },
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    methods: {
        normalizeFontSize,
        close() {
            this.visible = false
            this.$emit('cancel')
        },
    },
}
</script>
